module.exports = __webpack_public_path__ + "img/50.5f2bb66d.png";